import {AjaxAdd} from '../ajax-add';

import {ProductForm} from '../product-form';
import '../product-form/product-form.pcss';

import {LowStock} from '../low-stock';
import '../low-stock/low-stock.pcss';

import {Modal} from '../modal';
import {ModalTrigger} from '../modal/modal-trigger';
import '../modal/modal.pcss';

import {GalleryFullscreen} from '../gallery-fullscreen';
import {mountReact} from '../../utils';
import {VideoPlayer} from '../video-player';

import Glide, { Controls, Breakpoints } from '@glidejs/glide';

import { ProductComingSoonCountdown } from '../product-coming-soon-countdown';

const options = {
  jsonSelector: '[data-product-json]'
}

const BaseProduct = {
  onLoad() {
    this.childConfig = {
      namespace: `.${this.id}`,
    };

    this.init();
  },

  init() {
    const productData = this.getProductData();
    const productForm = this.container.querySelector('[data-product-form]');
    const productGallery = this.container.querySelector('[data-gallery]');
    this.ProductForm = new ProductForm(productForm, {
      productData
    });

    if (productGallery) {
      this.setupGlide();
    }

    this.LowStock = new LowStock(this.container);
    this.AjaxAdd = new AjaxAdd(this.container);
    this.galleryFullscreen = new GalleryFullscreen(
      this.container,
      this.childConfig,
    );

    mountReact('#video-player', VideoPlayer);
    this.setupMagic360Modal();

    new ProductComingSoonCountdown();
  },

  getProductData() {
    const jsonElement = this.container.querySelector(options.jsonSelector);

    if (!jsonElement) {
      return;
    }

    const json = jsonElement.innerHTML;

    try {
      return JSON.parse(json);
    } catch (exception) {
      return;
    }
  },

  setupGlide() {
    this.Glide = new Glide(this.container.querySelector('[data-gallery]'), {
      rewind: false,
      type: 'slider',
    }).mount();

    this.GlideNav = new Glide(this.container.querySelector('[data-gallery-thumbs]'), {
      focusAt: 0,
      perView: 6,
      rewind: false,
      type: 'carousel',
      breakpoints: {
        1000: {
          perView: 0
        },
      }
    }).mount();

    this.container.querySelectorAll('.gallery__thumbsImage').forEach(thumb => {
      thumb.addEventListener('click', (event) => {
        this.Glide.go(`=${event.currentTarget.dataset.slideIndex}`);
      })
    });

    this.Glide.on('run', () => {
      this.GlideNav.go(`=${this.Glide.index}`);
    });

    this.GlideNav.on('run', () => {
      this.Glide.go(`=${this.GlideNav.index}`);
    });

    this.GlideNav.on(['mount.after', 'build.after', 'resize', 'update'], () => {
      if (!Glide.Sizes) {
        return;
      }

      Glide.Sizes.setupSlider();
      Glide.Sizes.setupWrapper();
    });
  },

  setupMagic360Modal() {
    const modal = document.querySelector('[data-360-modal]');
    const trigger = document.querySelector('[data-360-modal-trigger]');

    if (!modal || !trigger) {
      return;
    }

    new Modal(
      modal,
      {
        inertSelector: '[data-body-inert]',
        isStatic: true,
        modalSelector: '[data-360-modal]'
      }
    );

    new ModalTrigger(
      trigger,
      {
        shouldCache: true,
        targetModal: "[data-360-modal]"
      }
    );
  }
};

export default BaseProduct;
